import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import { EModBordered, IModBordered } from '@ucheba/utils/helpers/styles/mod.types'

const Block = styled.thead<StyledProps<IModBordered>>`
  color: ${sv.color.gray50};
  vertical-align: top;
  ${sm.font.small2};

  td {
    padding-right: ${sv.spacing.small};
    padding-bottom: ${sv.spacing.small};
    padding-top: 0;

    &:last-child {
      padding-right: 0;
    }
  }

  ${sm.mod(EModBordered.false)`
    td {
      border-bottom: none;
    }
  `};
`

export default { Block }
